import React, { ReactElement } from 'react';
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import de from "apexcharts/dist/locales/de.json";
import "./barchart.css";
import { BarChartData } from './chartTypes';
import serializeJavascript from 'serialize-javascript';

let barChartDataHeigth = true;

function setDefaultSeries(hideFehlerfrei: boolean, height: number) {
  if (hideFehlerfrei) {
    ApexCharts.exec("chartID", "hideSeries", 'Aufgezeichnete Daten');
    ApexCharts.exec("chartID", "hideSeries", 'Keine Daten');
    barChartDataHeigth = true;
  } else {
    barChartDataHeigth = false;
  }
  ApexCharts.exec("chartID", "updateOptions", { height: barChartDataHeigth ? 10 : height });
}

export default function BarChart(isUTC: boolean, barChartData: BarChartData): ReactElement {
  const barchartOptions: ApexOptions = {

    chart: {
      id: "chartID",
      width: '100%',
      animations: {
        enabled: false,
      },
      locales: [de],
      defaultLocale: "de",
      events: {
        mounted: () => setDefaultSeries(barChartData.series[2].data.length > 0, barChartData.height)
      },
      toolbar: {
        tools: {
          reset: false,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "60%"
      }
    },
    xaxis: {
      type: 'datetime',
      labels: {
        datetimeUTC: isUTC,
        style: {
          fontSize: '14px'
        }
      }
    },
    yaxis: {
      labels: {
        align: 'left',
        maxWidth: 270,
        style: {
          fontSize: '14px',
          cssClass: 'apexcharts-yaxis-label',
        }
      }
    },
    grid: {
      padding: {
        left: -25,
      },
    },
    tooltip: {
      x: {
        show: true,
        format: "dd.MM.yy HH:mm:ss"
      }
    },
    stroke: {
      width: 1
    },
    fill: {
      type: 'solid',
      opacity: 0.6
    },
    colors: ["#008000", "#d1d1d1", "#b90000",], //Fehlerfrei, Fehler, Keine Daten
    legend: {
      position: 'top',
      horizontalAlign: 'center',
      showForSingleSeries: true,
      fontSize: '16px',
      fontFamily: 'Arial'
    },

  };
  return (
    <div id="chartDiv">
      <ReactApexChart
        options={barchartOptions}
        series={JSON.parse(serializeJavascript(barChartData.series, { isJSON: true }))}
        type="rangeBar"
        height={barChartData.height}
      />
    </div>
  );
}